import { render, staticRenderFns } from "./MetricsNote.vue?vue&type=template&id=59053360"
import script from "./MetricsNote.vue?vue&type=script&lang=js"
export * from "./MetricsNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports